import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledEdit = styled.svg<IconProps>`
  & .cls-1,
  .cls-2 {
    fill: none;
  }

  & .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
    stroke-miterlimit: 10;
  }

  &.hover:hover,
  &.active {
    .cls-1 {
      fill: none;
    }

    .cls-2 {
      fill: var(--du-color-primary, #128370);
      stroke: var(--du-color-primary, #128370);
      stroke-miterlimit: 10;
    }
  }
`;

const EditIcon: React.FC<IconProps> = ({ active }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledEdit
      id='Edit-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <rect id='Margin_Rectangle' data-name='Margin Rectangle' className='cls-1' width='32' height='32' />
      <path
        id='Union_8'
        data-name='Union 8'
        className='cls-2'
        d='M-1987.668-2335.631l9.211-9.21,2.584-2.584a1,1,0,0,1,1.414,0l1.876,1.876a1,1,0,0,1,0,1.414l-2.584,2.584h0l-9.21,9.211-4.622,1.332Z'
        transform='translate(1997.211 2354.797)'
      />
    </StyledEdit>
  );
};

export default EditIcon;
